// extracted by mini-css-extract-plugin
export default {"button":"Button_button__jGVh-","lightButton":"Button_lightButton__oRiLa","smallButton":"Button_smallButton__TaOph"};